import script from "./InterruptorPago.vue?vue&type=script&setup=true&lang=ts"
export * from "./InterruptorPago.vue?vue&type=script&setup=true&lang=ts"

import "./InterruptorPago.vue?vue&type=style&index=0&id=092861ba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-092861ba"]])

export default __exports__